export const JSON_KEYWORD_INFO = [
  { value: 'ルート営業', keyword: 'route-sales' },
  { value: '営業アシスタント', keyword: 'sales-assistant' },
  { value: 'ルート配送', keyword: 'route-delivery' },
  { value: 'セールスドライバー', keyword: 'sales-driver' },
  { value: '会計事務', keyword: 'accounting-office' },
  { value: '営業事務', keyword: 'sales-office' },
  { value: '経理事務', keyword: 'bookkeeping-office' },
  { value: '受付事務', keyword: 'reception-office' },
  { value: '内勤営業', keyword: 'inside-sales' },
  { value: 'IT営業', keyword: 'it-sales' },
  { value: '販売', keyword: 'retail' },
  { value: 'マーケター', keyword: 'marketer' },
  { value: '製造', keyword: 'manufacturing' },
  { value: 'Web', keyword: 'web' },
  { value: '配送ドライバー', keyword: 'delivery-driver' },
  { value: '接客', keyword: 'hospitality' },
  { value: 'ホールスタッフ', keyword: 'hall-staff' },
  { value: 'カウンセラー', keyword: 'counselor' },
  { value: '児童相談員', keyword: 'child-counselor' },
  { value: '生活支援員', keyword: 'life-support' },
  { value: 'コンシェルジュ', keyword: 'concierge' },
  { value: '仕分', keyword: 'sorting' },
  { value: 'カスタマーサービス', keyword: 'customer-service' },
  { value: '弁当調理', keyword: 'bento-cooking' },
  { value: '広報・PR', keyword: 'pr' },
  { value: 'キャリアカウンセラー', keyword: 'career-counselor' },
  { value: '広告', keyword: 'advertising' },
  { value: 'ファイナンシャルプランナー', keyword: 'financial-planner' },
  { value: '労務', keyword: 'labor-management' },
  { value: '秘書', keyword: 'secretary' }
];

export const JOBBOX_SITE_INFO = [
  { value: 'ママスタセレクト', keyword: 'mamastar-select' }
};